import { combineReducers, configureStore } from "@reduxjs/toolkit"
import { setupListeners } from "@reduxjs/toolkit/query"
import { baseApi } from "./services"
import aviaSearchReducer from "./reducers/book/aviaSearchSlice"
import commonReducer from "./reducers/commonSlice"
import departamentsReducer from "./reducers/admin/departamentsSlice"
import statesReducer from "./reducers/admin/statesSlice"
import notifiesRducer from "./reducers/book/notifies"
import bundleSyncReducer from "./reducers/book/bundleSyncSlice"
import hotelsReducer from "./reducers/admin/hotels.jsx"
import { IS_PRODUCTION } from "../variables/config"

const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  aviaSearch: aviaSearchReducer,
  common: commonReducer,
  notifies: notifiesRducer,
  departaments: departamentsReducer,
  states: statesReducer,
  bundleSync: bundleSyncReducer,
  hotels: hotelsReducer,
})

export const setupStore = (embedConfig = {}) => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: { extraArgument: { embedConfig } },
      }).concat(baseApi.middleware),
    devTools: !IS_PRODUCTION,
  })
}

export const store = setupStore()
setupListeners(store.dispatch)

export default store
